import React, { useState, useEffect } from 'react';
import axios from 'axios';
import API_BASE from './apiBase';
import { FileText, CreditCard, Clipboard, Book, Car, BarChart3, Plus, ArrowLeft, Eye, Edit } from 'lucide-react';
import '../css/App.css';
import Swal from 'sweetalert2';

// const IDProofTypes = () => {
const IDProofConsent = ({ onBack, tenantId, token }) => {
  const [showAnalytics, setShowAnalytics] = useState(false);

  // const idProofTypes = [
  const [dataTypes, setDataTypes] = useState([]);

  const getActiveTenantId = () => {
    if (tenantId) return Number(tenantId);
    const local = localStorage.getItem('tenant_id');
    if (local) return Number(local);
    try {
      const u = JSON.parse(localStorage.getItem('user') || '{}');
      if (u.tenant_id || u.tenantId || u.tenant) return Number(u.tenant_id || u.tenantId || u.tenant);
    } catch (e) { }
    return null;
  };

  const fetchDataTypes = async () => {
    const tid = getActiveTenantId();
    try {
      const res = await axios.get(`${API_BASE}/manager/data-types`, {
        params: tid ? { tenant_id: tid } : {}
      });
      if (res.data && Array.isArray(res.data.data_types)) {
        const mapped = res.data.data_types.map(d => ({
          ...d,
          icon: <FileText className="card-icon" />
        }));
        setDataTypes(mapped);
        return;
      }
    } catch (err) {
      console.warn('Failed to load data types from server', err);
    }

    // fallback static data based on standard data_type_consent configuration
    setDataTypes([
      { id: 1, key: 'Email-Address', name: 'Email Address', description: 'Consent for Email Address verification and communication.', icon: <FileText className="card-icon" />, usage: 80, color: 'blue', is_default: true, tenant_id: null },
      { id: 2, key: 'Phone', name: 'Phone', description: 'Consent for Phone number verification and contact.', icon: <FileText className="card-icon" />, usage: 75, color: 'green', is_default: true, tenant_id: null },
      { id: 3, key: 'Address', name: 'Address', description: 'Consent for residential address verification and correspondence.', icon: <FileText className="card-icon" />, usage: 65, color: 'orange', is_default: true, tenant_id: null },
      { id: 4, key: 'Aadhaar', name: 'Aadhaar', description: 'Consent for Aadhaar card verification and data.', icon: <CreditCard className="card-icon" />, usage: 85, color: 'blue', is_default: true, tenant_id: null },
      { id: 5, key: 'Passport', name: 'Passport', description: 'Consent for Passport verification and data.', icon: <Book className="card-icon" />, usage: 60, color: 'purple', is_default: true, tenant_id: null },
      { id: 6, key: 'PAN', name: 'PAN', description: 'Consent for PAN card verification.', icon: <CreditCard className="card-icon" />, usage: 72, color: 'green', is_default: true, tenant_id: null },
      { id: 7, key: 'Voter-ID', name: 'Voter-ID', description: 'Consent for Voter ID verification and data.', icon: <Clipboard className="card-icon" />, usage: 58, color: 'orange', is_default: true, tenant_id: null },
      { id: 8, key: 'Driving-License', name: 'Driving-License', description: 'Consent for Driving License verification.', icon: <Car className="card-icon" />, usage: 50, color: 'blue', is_default: true, tenant_id: null },
      { id: 9, key: 'Bank-AC', name: 'Bank-AC', description: 'Consent for Bank Account verification and transaction records.', icon: <CreditCard className="card-icon" />, usage: 45, color: 'green', is_default: true, tenant_id: null },
      { id: 10, key: 'Ration-Card', name: 'Ration-Card', description: 'Consent for Ration card verification.', icon: <Clipboard className="card-icon" />, usage: 40, color: 'purple', is_default: true, tenant_id: null },
      { id: 11, key: 'customer-id', name: 'Customer-ID', description: 'Consent for Customer ID processing and account management.', icon: <FileText className="card-icon" />, usage: 55, color: 'blue', is_default: true, tenant_id: null },
      { id: 12, key: 'password', name: 'Password', description: 'Consent for credentials and security authentication.', icon: <FileText className="card-icon" />, usage: 35, color: 'red', is_default: true, tenant_id: null },
      { id: 13, key: 'Visa', name: 'Visa', description: 'Consent for Visa documentation and travel verification.', icon: <Book className="card-icon" />, usage: 30, color: 'orange', is_default: true, tenant_id: null },
      { id: 14, key: 'GST', name: 'GST', description: 'Consent for GST number and business tax verification.', icon: <FileText className="card-icon" />, usage: 25, color: 'purple', is_default: true, tenant_id: null }
    ]);
  };

  useEffect(() => { fetchDataTypes(); }, [tenantId]);

  // const totalUsage = idProofTypes.reduce((sum, type) => sum + type.usage, 0);
  // const avgUsage = Math.round(totalUsage / idProofTypes.length);
  const totalUsage = dataTypes.reduce((sum, type) => sum + type.usage, 0);
  const avgUsage = Math.round(totalUsage / Math.max(1, dataTypes.length));

  const [adding, setAdding] = useState(false);
  const [newType, setNewType] = useState({ name: '', description: '', usage: 0, color: 'blue' });
  const [selected, setSelected] = useState(null);
  const [editing, setEditing] = useState(false);
  const [hoveredId, setHoveredId] = useState(null);

  return (
    <div className="app-container">
      <div className="content-wrapper">
        {/* Header Section */}
        <div className="header-section">
          <h2 className="main-title">Data Types</h2>

          <div className="button-group">


            <button className="btn-add-data" onClick={() => { setAdding(a => !a); setSelected(null); setEditing(false); }}>
              <Plus className="btn-icon" />
              {adding ? 'Cancel' : 'Add'}
            </button>
            {/* <button className="btn-back"> */}

            <button className="btn-back" onClick={() => onBack && onBack()}>
              <ArrowLeft className="btn-icon" />
              Back
            </button>
          </div>
        </div>

        {/* Analytics Section */}
        {showAnalytics && (
          <div className="analytics-container">
            <div className="stats-grid">
              <div className="stat-card stat-blue">
                <div className="stat-icon-wrapper stat-icon-blue">
                  <span className="stat-emoji">📈</span>
                </div>
                <div className="stat-content">
                  <h3 className="stat-number">{totalUsage}</h3>
                  <p className="stat-label">Total Usage</p>
                </div>
              </div>

              <div className="stat-card stat-green">
                <div className="stat-icon-wrapper stat-icon-green">
                  <span className="stat-emoji">📊</span>
                </div>
                <div className="stat-content">
                  <h3 className="stat-number">{avgUsage}%</h3>
                  <p className="stat-label">Avg Usage</p>
                </div>
              </div>

              <div className="stat-card stat-orange">
                <div className="stat-icon-wrapper stat-icon-orange">
                  <span className="stat-emoji">🎯</span>
                </div>
                <div className="stat-content">
                  {/* <h3 className="start-number">{idProofTypes.length}</h3> */}
                  <h3 className="stat-number">{dataTypes.length}</h3>
                  <p className="stat-label">Data Types</p>
                </div>
              </div>
            </div>

            <div className="usage-statistics">
              <h3 className="usage-title">Usage Statistics</h3>
              <div className="usage-bars">
                {/* {idProofTypes.map((type) => ( */}
                {dataTypes.map((type) => (
                  <div key={type.id} className="usage-row">
                    <div className="usage-label">
                      <div className={`usage-icon-wrapper icon-${type.color}`}>
                        {type.icon}
                      </div>
                      <span className="usage-name">{type.name}</span>
                    </div>
                    <div className="usage-bar-container">
                      <div className="usage-bar-bg">
                        <div
                          className={`usage-bar bar-${type.color}`}
                          style={{ width: `${type.usage}%` }}
                        ></div>
                      </div>
                    </div>
                    <span className="usage-percentage">{type.usage}%</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* Add new type inline */}
        {adding && (
          // <div className="p-4 mb-4 bg-gray-50 rounded">
          //   <div className ="flex gap-2 mb-2">
          //     <input className="flex-1 px-3 py-2 border rounded" placeholder="Type name" value={newType.name} onChange={e => setNewType({ ...newType, name: e.target.value })} />
          //     <input className="w-28 px-3 py-2 border rounded placeholder="Usage %" value={newType.usage} onChange={e => setNewType({ ...newType, usage: Number(e.target.value) })} />
          <div style={{ position: 'fixed', top: 0, right: 0, width: 380, maxWidth: '92%', height: '100%', background: '#ffffff', boxShadow: '-4px 0 16px rgba(0,0,0,0.12)', transition: 'transform 0.25s ease', zIndex: 1000, padding: 20, overflowY: 'auto' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
              <h3 style={{ margin: 0 }}>Add Data Type</h3>
              <button className="btn-back" onClick={() => { setAdding(false); setNewType({ name: '', description: '', usage: 0, color: 'blue' }); }}>Close</button>
            </div>

            <div style={{ marginBottom: 12 }}>
              <input className="w-full px-3 py-2 border rounded" placeholder="Type name" value={newType.name} onChange={e => setNewType({ ...newType, name: e.target.value })} />
            </div>

            <div style={{ marginBottom: 12 }}>
              <input className="w-full px-3 py-2 border rounded" placeholder="Description" value={newType.description} onChange={e => setNewType({ ...newType, description: e.target.value })} />
            </div>
            {/* <div className ="flex gap-2 mb-4">
              <input className="flex-1 px-3 py-2 border rounded" placeholder="Description" value={newType.description} onChange={e => setNewType({ ...newType, description:e.target.value})} />
              <select value={newType.color} onChange={e => setNewType({ ...newType, color: e.target.value })} className="px-3 py-2 border rounded"> */}

            <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
              {/* <input className="px-3 py-2 border rounded" placeholder="Usage %" value={newType.usage} onChange={e => setNewType({ ...newType, usage: Number(e.target.value) })} /> */}
              <select value={newType.color} onChange={e => setNewType({ ...newType, color: e.target.value })} className="px-3 py-2 border rounded">
                <option value="blue">Blue</option>
                <option value="green">Green</option>
                <option value="orange">Orange</option>
                <option value="purple">Purple</option>
                <option value="red">Red</option>
              </select>
            </div>
            {/* <div className="flex gap-2">
              <button className="px-3 py-2 bg-indigo-600 text-white rounded" onClick={() => {
                const name = (newType.name || '').trim();
                if (!name) return alert('Enter a name'); */}

            <div style={{ display: 'flex', gap: 8 }}>
              {/* <button className="px-3 py-2 bg-indigo-600 text-while rounded" onClick={() =>{ */}
              <button className="px-3 py-2 bg-indigo-600 text-white rounded" onClick={async () => {
                const name = (newType.name || '').trim();
                if (!name) { Swal.fire({ icon: 'warning', title: 'Missing Name', text: 'Enter a name', customClass: { popup: 'swal-popup-custom' } }); return; }
                const tid = getActiveTenantId();
                try {
                  const payload = {
                    name,
                    key: name.trim().replace(/\s+/g, '-'),
                    description: newType.description || null,
                    usage: Number(newType.usage) || 0,
                    color: newType.color || 'blue',
                    tenant_id: tid
                  };
                  const res = await axios.post(`${API_BASE}/manager/data_types_proof`, payload);
                  if (res.data && res.data.success) {
                    // re-fetch from server so the new item is persisted on reload
                    await fetchDataTypes();
                    try { window.dispatchEvent(new CustomEvent('dataTypesUpdated', { detail: { action: 'create', id: res.data.id || null, tenant_id: tid } })); } catch (e) { }
                    setNewType({ name: '', description: '', usage: 0, color: 'blue' });
                    setAdding(false);
                    Swal.fire({ icon: 'success', title: 'Created', text: 'Data type added successfully', customClass: { popup: 'swal-popup-custom' } });
                  } else {
                    Swal.fire({ icon: 'error', title: 'Save Failed', text: 'Failed to save type', customClass: { popup: 'swal-popup-custom' } });
                  }
                } catch (err) {
                  console.error('Failed to save data type', err);
                  Swal.fire({ icon: 'error', title: 'Save Failed', text: 'Failed to save data type to server', customClass: { popup: 'swal-popup-custom' } });
                }
              }}>Create</button>
              {/* <button className ="px-3 py-2 bg-gray-200 rounded" onClick={() => { setAdding(false); setNewType({ name: '', description: '', usage: 0, color: 'blue' }); }}>Cancel</button> */}

              <button className="px-3 py-2 bg-gray-200 rounded" onClick={() => { setAdding(false); setNewType({ name: '', description: '', usage: 0, color: 'blue' }); }}>Cancel</button>
            </div>
          </div>
        )}
        {/* ID Proof Cards Grid */}
        <div className="cards-grid">
          {/* {idProofTypes.map((type) => (
            <div key={type.id} className="consent-card"> */}
          {dataTypes.map((type) => (
            // <div key={type.id} className="consent-card cursor-pointer" onClick={() => setHoveredId(type); setEditing(false); }}>
            <div key={type.id} className="consent-card cursor-pointer" onMouseEnter={() => setHoveredId(type.id)} onMouseLeave={() => setHoveredId(null)} onClick={() => { setSelected(type); setEditing(false); }} style={{ position: 'relative' }}>
              {/* Action icons shown on hover */}
              {hoveredId === type.id && (
                <div style={{ position: 'absolute', top: 8, right: 8, display: 'flex', gap: 8, zIndex: 2 }}>
                  {/* <button title="View" onClick={(e) => { e.stopPropagation(); setSelected(type); setEditing(false); }} style={{ background: 'rgba(0,0,0,0.06)', border: 'none', padding: 6, borderRadius: 6, cursor: 'pointer' }}>
                    <Eye size={16} />
                  </button>
                  <button title="Edit" onClick={(e) => { e.stopPropagation(); setSelected(type); setEditing(true); setNewType({ name: type.name, description: type.description, usage: type.usage, color: type.color }); }} style={{ background: 'rgba(0,0,0,0.06)', border: 'none', padding: 6, borderRadius: 6, cursor: 'pointer' }}>
                    <Edit size={16} />
                  </button> */}
                  <button
                    style={{
                      background: 'transparent',
                      border: 'none',
                      padding: 10,
                      borderRadius: 10,
                      cursor: 'pointer',
                      transition: 'all 0.2s ease',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = '#2563eb';
                      e.currentTarget.querySelector('svg').style.color = '#ffffff';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = 'transparent';
                      e.currentTarget.querySelector('svg').style.color = '';
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelected(type);
                      setEditing(false);
                    }}
                  >
                    <Eye size={18} />
                  </button>



                  {/* EDIT (allows configuring display value/name without changing permanent key) */}
                  <button
                    style={{
                      background: 'transparent',
                      border: 'none',
                      padding: 10,
                      borderRadius: 10,
                      cursor: 'pointer',
                      transition: 'all 0.2s ease',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = '#16a34a';
                      e.currentTarget.querySelector('svg').style.color = '#ffffff';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = 'transparent';
                      e.currentTarget.querySelector('svg').style.color = '';
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelected(type);
                      setEditing(true);
                      setNewType({
                        name: type.value || type.name,
                        key: type.key,
                        description: type.description,
                        usage: type.usage,
                        color: type.color
                      });
                    }}
                  >
                    <Edit size={18} />
                  </button>
                </div>
              )}
              <div className="card-content">
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative', width: '100%' }}>
                  <div className={`card-icon-wrapper icon-bg-${type.color}`}>
                    {type.icon || <FileText className="card-icon" />}
                  </div>
                </div>
                <h3 className="card-title" style={{ marginBottom: 4 }}>{type.value || type.name}</h3>
                <p className="card-description">{type.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Selected / Edit modal popup */}
        {selected && (() => {
          const isDefault = selected.is_default || selected.tenant_id === null || selected.tenant_id === undefined;
          return (
            <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1100 }} onClick={() => { setSelected(null); setEditing(false); }}>
              <div style={{ width: 640, maxWidth: '94%', background: '#fff', borderRadius: 8, padding: 20 }} onClick={(e) => e.stopPropagation()}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                  <div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <h4 style={{ margin: 0 }}>{selected.value || selected.name}</h4>
                      {isDefault ? (
                        <span style={{ background: '#eff6ff', color: '#1d4ed8', border: '1px solid #bfdbfe', padding: '2px 8px', borderRadius: 4, fontSize: 11, fontWeight: 600 }}>Default System Type</span>
                      ) : (
                        <span style={{ background: '#f0fdf4', color: '#15803d', border: '1px solid #bbf7d0', padding: '2px 8px', borderRadius: 4, fontSize: 11, fontWeight: 600 }}>Custom Data Type</span>
                      )}
                    </div>
                    <div className="text-xs text-gray-600" style={{ marginTop: 4 }}>{selected.description}</div>
                  </div>
                  <div style={{ display: 'flex', gap: 8 }}>
                    {!editing && (
                      <button className="px-3 py-1 bg-indigo-600 text-white rounded" onClick={() => { setEditing(true); setNewType({ name: selected.value || selected.name, key: selected.key, description: selected.description, usage: selected.usage, color: selected.color }); }}>Edit</button>
                    )}
                    {editing && (
                      <>
                        <button className="px-3 py-1 bg-green-600 text-white rounded" onClick={() => {
                          (async () => {
                            const val = (newType.name || '').trim();
                            if (!val) {
                              Swal.fire({ icon: 'warning', title: 'Missing Value', text: 'Enter a display name/value', customClass: { popup: 'swal-popup-custom' } });
                              return;
                            }
                            const tid = getActiveTenantId();
                            const payload = {
                              name: val,
                              value: val,
                              description: newType.description,
                              usage: Number(newType.usage) || 0,
                              color: newType.color,
                              tenant_id: tid
                            };
                            try {
                              await axios.put(`${API_BASE}/manager/data_types_proof/${selected.id}`, payload);
                              await fetchDataTypes();
                              try { window.dispatchEvent(new CustomEvent('dataTypesUpdated', { detail: { action: 'update', id: selected.id, tenant_id: tid } })); } catch (e) { }
                              Swal.fire({ icon: 'success', title: 'Updated', text: 'Data type value updated successfully', customClass: { popup: 'swal-popup-custom' } });
                            } catch (err) {
                              setDataTypes(prev => prev.map(d => d.id === selected.id ? { ...d, name: val, value: val, description: newType.description, usage: Number(newType.usage) || 0, color: newType.color } : d));
                              try { window.dispatchEvent(new CustomEvent('dataTypesUpdated', { detail: { action: 'update', id: selected.id, tenant_id: tid } })); } catch (e) { }
                              Swal.fire({ icon: 'warning', title: 'Updated locally', text: 'Saved on this device: ' + (err?.response?.data?.detail || err?.message || ''), customClass: { popup: 'swal-popup-custom' } });
                            }
                            setSelected(null);
                            setEditing(false);
                          })();
                        }}>Save</button>
                        <button className="px-3 py-1 bg-gray-200 rounded" onClick={() => { setEditing(false); }}>Cancel</button>
                      </>
                    )}
                    {!isDefault && (
                      <button className="px-3 py-1 bg-red-500 text-white rounded" onClick={async () => {
                        const typeToDelete = selected;
                        setSelected(null);
                        setEditing(false);

                        const result = await Swal.fire({
                          title: 'Delete Data Type',
                          text: `Delete "${typeToDelete.value || typeToDelete.name}"? This cannot be undone.`,
                          icon: 'warning',
                          showCancelButton: true,
                          confirmButtonText: 'Delete',
                          cancelButtonText: 'Cancel',
                          confirmButtonColor: '#ef4444',
                          customClass: { popup: 'swal-popup-custom' }
                        });

                        if (!result.isConfirmed) {
                          setSelected(typeToDelete);
                          setEditing(false);
                          return;
                        }

                        const tid = getActiveTenantId();
                        try {
                          await axios.delete(`${API_BASE}/manager/data_types_proof/${typeToDelete.id}`, {
                            params: tid ? { tenant_id: tid } : {}
                          });
                          await fetchDataTypes();
                          try { window.dispatchEvent(new CustomEvent('dataTypesUpdated', { detail: { action: 'delete', id: typeToDelete.id, tenant_id: tid } })); } catch (e) { }
                          Swal.fire({ icon: 'success', title: 'Deleted', text: 'Data type has been deleted successfully', customClass: { popup: 'swal-popup-custom' } });
                        } catch (err) {
                          setDataTypes(prev => prev.filter(d => d.id !== typeToDelete.id));
                          try { window.dispatchEvent(new CustomEvent('dataTypesUpdated', { detail: { action: 'delete', id: typeToDelete.id, tenant_id: tid } })); } catch (e) { }
                          Swal.fire({ icon: 'warning', title: 'Deleted locally', text: 'Removed on this device: ' + (err?.response?.data?.detail || err?.message || ''), customClass: { popup: 'swal-popup-custom' } });
                        }
                      }}>Delete</button>
                    )}
                    <button className="px-3 py-1 bg-gray-200 rounded" onClick={() => { setSelected(null); setEditing(false); }}>Close</button>
                  </div>
                </div>

                <div style={{ margin: '10px 0 14px 0', padding: '8px 12px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <div>
                    <span style={{ fontSize: 11, fontWeight: 700, color: '#475569', textTransform: 'uppercase', letterSpacing: 0.5 }}>Permanent Key (Immutable):</span>
                    <div style={{ fontSize: 13, fontWeight: 700, color: '#0f172a', fontFamily: 'monospace', marginTop: 2 }}>
                      {selected.key || (selected.value || selected.name || '').trim().replace(/[^a-zA-Z0-9]+/g, '-').replace(/^-+|-+$/g, '')}
                    </div>
                  </div>
                  <span style={{ fontSize: 11, color: '#64748b', fontStyle: 'italic' }}>Key never changes; display value can be updated</span>
                </div>

                {!editing ? (
                  <div>
                    <p><strong>Display Value:</strong> {selected.value || selected.name}</p>
                    <p><strong>Description:</strong> {selected.description}</p>
                    {/* <p><strong>Usage:</strong> {selected.usage}%</p> */}
                    <p><strong>Color:</strong> {selected.color}</p>
                  </div>
                ) : (
                  <div className="mt-3" style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                    <div>
                      <label style={{ fontSize: 12, fontWeight: 600, color: '#475569', display: 'block', marginBottom: 4 }}>Display Value / Label:</label>
                      <input className="w-full px-3 py-2 border rounded" placeholder="Display Value / Name" value={newType.name} onChange={e => setNewType({ ...newType, name: e.target.value })} />
                    </div>
                    <div>
                      <label style={{ fontSize: 12, fontWeight: 600, color: '#475569', display: 'block', marginBottom: 4 }}>Description:</label>
                      <input className="w-full px-3 py-2 border rounded" placeholder="Description" value={newType.description} onChange={e => setNewType({ ...newType, description: e.target.value })} />
                    </div>
                    <div style={{ display: 'flex', gap: 8 }}>
                      {/* <input className="px-3 py-2 border rounded" value={newType.usage} onChange={e => setNewType({ ...newType, usage: Number(e.target.value) })} /> */}
                      <select value={newType.color} onChange={e => setNewType({ ...newType, color: e.target.value })} className="px-3 py-2 border rounded">
                        <option value="blue">Blue</option>
                        <option value="green">Green</option>
                        <option value="orange">Orange</option>
                        <option value="purple">Purple</option>
                        <option value="red">Red</option>
                      </select>
                    </div>
                  </div>
                )}
              </div>
            </div>
          );
        })()}
      </div>
    </div>
  );
};

export default IDProofConsent;